// extracted by mini-css-extract-plugin
module.exports = {"button":"StudentList_button__3ZrUv","full-width-avatar":"StudentList_full-width-avatar__cUIwt","container":"StudentList_container__2Vv04"};